        
     export default function(){
        const firstDayTr = document.querySelector('[data-trigger-firstDay]');
        const lastDayTr = document.querySelector('[data-trigger-lastDay]');
        var now = new Date();
        var firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        var lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        firstDayTr.textContent = date2Str(firstDay);
        lastDayTr.textContent = date2Str(lastDay);

        function date2Str(date) {
            var year = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();
            var output = year + '年' + (String(month + 1).padStart(2, '0')) + '月' + String(day).padStart(2, '0') + '日';
            
            return output;
        }
     }
        // var now = new Date(), y = now.getFullYear(), m = now.getMonth();
        // var firstDay = new Date(y, m, 1);
        // var lastDay = new Date(y, m + 1, 0);

        // document.getElementById('testfirstDay').textContent = date2Str(firstDay);
        // document.getElementById('testlastDay').textContent = date2Str(lastDay);

        // function date2Str(date) {
        //     var year = date.getFullYear();
        //     var month = date.getMonth();
        //     var day = date.getDate();
        //     var output = year + '年' + (String(month + 1).padStart(2, '0')) + '月' + String(day).padStart(2, '0') + '日';
            
        //     return output;
        // }


// WEBPACK FOOTER //
// ./src/js/util/date.js